import React, { useState, useContext, useEffect, useCallback } from 'react';
import { AuthContext } from '../auth/ContextAuthentication';
import { ErrorLoadingContext } from '../auth/ErrorLoadingContext';
import useAxiosConfig from '../config/AxiosConfig';
import { useLocation } from 'react-router-dom';

import BookingTable from '../component/BookingTable';
import CreateBookingModal from '../component/CreateBookingModal';
import {
  Autocomplete,
  TextField,
  CircularProgress,
  Button,
  Pagination,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  IconButton,
} from '@mui/material';

import ClearIcon from '@mui/icons-material/Clear';

const SportsBookings = () => {
  const axiosInstance = useAxiosConfig();
  const {
  setBookingData
} = useContext(AuthContext);
  useState([]);
  const { setLoading, setError } = useContext(ErrorLoadingContext);
  const [sports, setSports] = useState([]);
  const [grounds, setGrounds] = useState([]);
  const [selectedSport, setSelectedSport] = useState(null);
  const [selectedGround, setSelectedGround] = useState(null);
  const [groundMap] = useState([]);
  const [isLoadingGrounds, setIsLoadingGrounds] = useState(false);
  const [isFetchingBookings, setIsFetchingBookings] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const { adminRole } = useContext(AuthContext);
  const [totalPages, setTotalPages] = useState(0);
  const [, setTotalBookings] = useState(0);
  const [page, setPage] = useState(1);
  const [selectedApp, setSelectedApp] = useState('');
  useState(false);
  const [showCreateBookingModal, setShowCreateBookingModal] = useState(false);

  const headerData = [
    'User Name',
    'Phone No',
    'Booking Date',
    'Ground Name',
    'Sport Name',
    'Field',
    'Time Slot',
    'Duration',
    'Advance Amount',
    'Remaining Amount',
    'Promo Code',
    'Promo Created By',
    'Discount Amount',
    'Discount Percentage',
    "Manager's Name",
    "Manager's No",
    'Status',
    'Actions',
  ];

  const appLabels = {
    groundapp: 'Ground App',
    maidanapp: 'Maidan App',
    rox: 'Rox App',
    sportx: 'Sportx App',
    dhoond: 'Dhoond App',
    admin: 'Admin Panel',
  };

  const location = useLocation();
  const initialGround = location?.state?.ground;

  useEffect(() => {
    if (initialGround) {
      setSelectedGround(initialGround);
    }
  }, [initialGround]);

  const fetchAllSports = useCallback(async () => {
    setIsLoadingGrounds(true);
    try {
      const response = await axiosInstance.get('/api/ground/get-all-sports');
      const sports = response.data.data;
      setSports(sports);
    } catch (error) {
      setError('Error fetching sports');
    } finally {
      setIsLoadingGrounds(false);
    }
  }, [axiosInstance, setError]);

  const fetchGroundsBySport = useCallback(async () => {
    setIsLoadingGrounds(true);
    try {
      // Try to get grounds with full details including fields
      const response = await axiosInstance.get('/api/admin/get-all-grounds');
      const grounds = response.data.grounds || response.data.data || [];
      setGrounds(grounds);
    } catch (error) {
      // Fallback to bookings-grounds endpoint
      try {
        const response = await axiosInstance.get(
          '/api/admin/get-all-bookings-grounds',
        );
        const grounds = response.data.data || [];
        setGrounds(grounds);
      } catch (fallbackError) {
        setError('Error fetching grounds');
        setGrounds([]);
      }
    } finally {
      setIsLoadingGrounds(false);
    }
  }, [axiosInstance, setError]);

  const fetchBookings = useCallback(async () => {
    // console.log('called');
    try {
      const baseUrl = 'api/admin/sports/get-bookings-by-grounds-and-sports';

      // Create an object to store query parameters
      const queryParams = new URLSearchParams();

      // Add date parameters if both exist
      if (startDate && endDate) {
        console.log('startDate, endDate', startDate, endDate);
        queryParams.append('startDate', startDate);
        queryParams.append('endDate', endDate);
      }

      // Add groundId parameter
      queryParams.append('groundId', selectedGround?._id || '');

      // Add sportsId parameter
      queryParams.append('sportsId', selectedSport?._id || '');

      // Add page parameter
      queryParams.append('page', page);
      queryParams.append('limit', 50);

      if (selectedApp) {
        queryParams.append('bookingSourceApp', selectedApp);

        // queryParams.append(
        //   'fromMaidanApp',
        //   selectedApp === 'Maidan App' ? true : false,
        // );
      }
      // Construct final URL
      const url = `${baseUrl}?${queryParams.toString()}`;
      setIsFetchingBookings(true);
      const response = await axiosInstance.get(url);
      console.log('bookings', JSON.stringify(response));

      // console.log('response?.data?.data', response);
      setBookingData(response.data.data || []);
      setTotalPages(response.data.totalPages);
      setTotalBookings(response.data.totalBookings);
    } catch (error) {
      setError('Error fetching bookings');
      setBookingData([]);
    } finally {
      setIsFetchingBookings(false);
    }
  }, [axiosInstance, endDate, page, selectedApp, selectedGround, selectedSport, setBookingData, setError, startDate]);

  useEffect(() => {
    fetchAllSports();
    fetchGroundsBySport();
  }, [fetchAllSports, fetchGroundsBySport]);

  useEffect(() => {
    const shouldFetch = !initialGround || (initialGround && selectedGround);
    if (shouldFetch) {
      fetchBookings();
    }
  }, [fetchBookings, initialGround, selectedGround]);

  const exportBookings = async () => {
    // console.log('called');
    try {
      // const baseUrl = 'api/admin/sports/get-bookings-by-grounds-and-sports';
      const baseUrl = 'api/admin/sports/export-bookings-to-excel';

      // Create an object to store query parameters
      const queryParams = new URLSearchParams();

      // Add date parameters if both exist
      if (startDate && endDate) {
        console.log('startDate, endDate', startDate, endDate);
        queryParams.append('startDate', startDate);
        queryParams.append('endDate', endDate);
      }

      // Add groundId parameter
      queryParams.append('groundId', selectedGround?._id || '');

      // Add sportsId parameter
      queryParams.append('sportsId', selectedSport?._id || '');

      // Add page parameter
      // queryParams.append('page', page);
      // queryParams.append('limit', 50);

      if (selectedApp) {
        queryParams.append('bookingSourceApp', selectedApp);
        // queryParams.append(
        //   'fromMaidanApp',
        //   selectedApp === 'Maidan App' ? true : false,
        // );
      }
      // Construct final URL
      const url = `${baseUrl}?${queryParams.toString()}`;
      setIsFetchingBookings(true);
      const response = await axiosInstance.get(url);
      console.log('export data link', JSON.stringify(response));
      const downloadUrl =
        response?.data?.data?.downloadUrl || response?.data?.downloadUrl;

      if (downloadUrl) {
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = response?.data?.data?.fileName || 'Bookings.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      // console.log('response?.data?.data', response);
      // setBookingData(response.data.data || []);
      // setTotalPages(response.data.totalPages);
      // setTotalBookings(response.data.totalBookings);
    } catch (error) {
      setError('Error fetching bookings');
      setBookingData([]);
    } finally {
      setIsFetchingBookings(false);
    }
  };







  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleCreateBooking = () => {
    setShowCreateBookingModal(true);
  };

  const handleCloseCreateBookingModal = () => {
    setShowCreateBookingModal(false);
  };

  const handleSaveBooking = async bookingData => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        '/api/admin/create-booking',
        bookingData,
      );

      if (response.status === 200 || response.status === 201) {
        setError(null);
        setShowCreateBookingModal(false);
        // Refresh bookings list
        fetchBookings();
      }
    } catch (error) {
      console.error('Error creating booking:', error);
      setError(
        error.response?.data?.message ||
          'Error creating booking. Please try again.',
      );
    } finally {
      setLoading(false);
    }
  };

  // const handleExportToExcel = async () => {
  //   if (bookingData?.length > 0) {
  //     const formattedData = bookingData?.map((row) => ({
  //       UserName: row?.owner?.fullName || "-",
  //       PhoneNO: row?.owner?.phone_no || "-",
  //       BookingDate: row?.date ? formatDate(row.date) : "-",
  //       GroundName: row?.ground?.name || "-",
  //       SportName: row?.sportsId?.name || "-",
  //       Field: row?.fieldData?.name || "-",
  //       TimeSlot:
  //         row?.startTime && row?.endTime
  //           ? `${formatTime(row.startTime)} - ${formatTime(row.endTime)}`
  //           : "-",
  //       AdvanceAmount: row?.paidAmount ?? 0,
  //       RemainingAmount: row?.remainingAmount ?? 0,
  //       PromoCode: row?.promoCode || "-",
  //       DiscountAmount: row.promoCode
  //         ? (parseFloat(row.bookingFee) * row.promoCode.discount) / 100
  //         : 0,
  //       DiscountPercentage: row?.promoCode?.discount || "-",
  //       ManagersName: row?.owner?.fullName || "-",
  //       ManagersNo: row?.owner?.phone_no || "-",
  //       status: row?.status || "-",
  //     }));

  //     // Calculate totals
  //     const totalAdvance = formattedData.reduce(
  //       (sum, row) => sum + (parseFloat(row.AdvanceAmount) || 0),
  //       0
  //     );
  //     const totalRemaining = formattedData.reduce(
  //       (sum, row) => sum + (parseFloat(row.RemainingAmount) || 0),
  //       0
  //     );
  //     // Calculate total advance and remaining amounts
  //     const totalRevenue = formattedData.reduce(
  //       (sum, row) => parseFloat(totalAdvance + totalRemaining) || 0,
  //       0
  //     );

  //     // Add summary rows
  //     formattedData.push({
  //       UserName: "",
  //       PhoneNO: "",
  //       BookingDate: "",
  //       GroundName: "",
  //       SportName: "",
  //       Field: "",
  //       TimeSlot: "",
  //       AdvanceAmount: "Total Advance Amount",
  //       RemainingAmount: totalAdvance,
  //       PromoCode: "",
  //       DiscountAmount: "",
  //       DiscountPercentage: "",
  //       ManagersName: "",
  //       ManagersNo: "",
  //       status: "",
  //     });
  //     formattedData.push({
  //       UserName: "",
  //       PhoneNO: "",
  //       BookingDate: "",
  //       GroundName: "",
  //       SportName: "",
  //       Field: "",
  //       TimeSlot: "",
  //       AdvanceAmount: "Total Remaining Amount",
  //       RemainingAmount: totalRemaining,
  //       PromoCode: "",
  //       DiscountAmount: "",
  //       DiscountPercentage: "",
  //       ManagersName: "",
  //       ManagersNo: "",
  //       status: "",
  //     });

  //     formattedData.push({
  //       UserName: "",
  //       PhoneNO: "",
  //       BookingDate: "",
  //       GroundName: "",
  //       SportName: "",
  //       Field: "",
  //       TimeSlot: "",
  //       AdvanceAmount: "Total Revenue Amount",
  //       RemainingAmount: totalRevenue,
  //       PromoCode: "",
  //       DiscountAmount: "",
  //       DiscountPercentage: "",
  //       ManagersName: "",
  //       ManagersNo: "",
  //       status: "",
  //     });

  //     const worksheet = XLSX.utils.json_to_sheet(formattedData);
  //     worksheet["!cols"] = [{ wch: 30 }, { wch: 40 }, { wch: 30 }];

  //     XLSX.utils.sheet_add_aoa(
  //       worksheet,
  //       [
  //         [
  //           "UserName",
  //           "PhoneNO",
  //           "BookingDate",
  //           "GroundName",
  //           "SportName",
  //           "Field",
  //           "TimeSlot",
  //           "AdvanceAmount",
  //           "RemainingAmount",
  //           "PromoCode",
  //           "DiscountAmount",
  //           "DiscountPercentage",
  //           "ManagersName",
  //           "ManagersNo",
  //           "status",
  //         ],
  //       ],
  //       {
  //         origin: "A1",
  //       }
  //     );

  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Players");

  //     await XLSX.writeFile(workbook, "BookingDetails.xlsx");
  //   }
  // };



  return (
    <div className="p-4 w-full">
      <h2 className="text-xl font-bold mb-4">Bookings</h2>

      <div className="mb-4 flex gap-4">
        <Autocomplete
          options={sports}
          getOptionLabel={option => option.name}
          style={{ width: 300 }}
          renderInput={params => (
            <TextField
              {...params}
              label="Select Sport"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isLoadingGrounds ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          onChange={(event, newValue) => {
            setSelectedSport(newValue);
            if (newValue) {
              fetchGroundsBySport(newValue._id);
            } else {
              // setGrounds([]);
            }
          }}
          loading={isLoadingGrounds}
        />
        <Autocomplete
          options={grounds || 'Nothing'}
          value={selectedGround}
          getOptionLabel={option => option.name}
          style={{ width: 300 }}
          renderInput={params => (
            <TextField
              {...params}
              label="Select Ground"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isLoadingGrounds ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          onChange={(event, newValue) => {
            setSelectedGround(newValue);
          }}
          loading={isLoadingGrounds}
        />
        <TextField
          label="Start Date"
          type="date"
          value={startDate}
          onChange={e => {
            // Check if this is a real user selection rather than month navigation
            if (e.target.value !== startDate) {
              setStartDate(e.target.value);
            }
          }}
          onClick={e => e.stopPropagation()} // Prevent event bubbling
          InputLabelProps={{ shrink: true }}
          style={{ width: 300 }}
        />

        <TextField
          label="End Date"
          type="date"
          value={endDate}
          onChange={e => {
            if (e.target.value !== endDate) {
              setEndDate(e.target.value);
            }
          }}
          onClick={e => e.stopPropagation()} // Prevent event bubbling
          InputLabelProps={{ shrink: true }}
          style={{ width: 300 }}
        />
        <FormControl style={{ width: 300 }}>
          <InputLabel id="app-select">Select App</InputLabel>
          <Select
            label="Select App"
            labelId="app-select"
            value={selectedApp}
            onChange={e => setSelectedApp(e.target.value)}
            renderValue={value => (value ? appLabels[value] : 'Select App')}
            endAdornment={
              selectedApp && (
                <IconButton
                  size="small"
                  onClick={() => setSelectedApp('')}
                  sx={{ marginRight: '24px' }}>
                  <ClearIcon />
                </IconButton>
              )
            }>
            <MenuItem value="groundapp">Ground App</MenuItem>
            <MenuItem value="maidanapp">Maidan App</MenuItem>
            <MenuItem value="rox">Rox App</MenuItem>
            <MenuItem value="sportx">Sportx App</MenuItem>
            <MenuItem value="dhoond">Dhoond App</MenuItem>
            <MenuItem value="admin">Admin Panel</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="contained"
          onClick={handleCreateBooking}
          sx={{
            backgroundColor: '#0C7240',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#0C7240',
              boxShadow: 'none',
            },
          }}>
          CREATE BOOKING
        </Button>
        {isLoadingGrounds ? (
          <CircularProgress color="inherit" size={20} />
        ) : (
          <Button
            variant="contained"
            // onClick={handleExportToExcel}
            onClick={exportBookings}
            disabled={adminRole !== 'Super Admin'}
            sx={{
              backgroundColor:
                adminRole === 'Super Admin' ? '#0C7240' : '#B0B0B0',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor:
                  adminRole === 'Super Admin' ? '#0C7240' : '#B0B0B0',
                boxShadow: 'none',
              },
              cursor: adminRole === 'Super Admin' ? 'pointer' : 'not-allowed',
            }}>
            EXPORT
          </Button>
        )}
      </div>
      <BookingTable
        headerData={headerData}
        isLoading={isFetchingBookings}
        groundMap={groundMap}
        selectedApp={selectedApp}
      />
      <div className="w-[70%] mx-auto flex justify-center">
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
        />
      </div>

      <CreateBookingModal
        showModal={showCreateBookingModal}
        handleClose={handleCloseCreateBookingModal}
        handleSave={handleSaveBooking}
        grounds={grounds}
        isLoadingGrounds={isLoadingGrounds}
      />
    </div>
  );
};

export default SportsBookings;
